import axios from 'axios';
import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import { AiOutlineEye } from "react-icons/ai";
import { toast } from '../../utils/toast';
import { useSubmitGuard } from '../../utils/useSubmitGuard';

import {
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button
} from '@mui/material';

import "../../styles/Admin-ui/Admin-DoctorsList.css";
import { API_DETAILS } from '../../App';
import "../../styles/Admin-ui/Admin-PopUps.css";

const DynamicInputBox = ({ inputText, onInputChange, notesTextareaRef, setInputText }) => {
     
    
    return (
        
        <div className="dynamic-input-box"style={{ marginLeft:30,marginTop:30}} >
            <label htmlFor="fieldType" style={{ textAlign: 'left', display: 'block' }} >Notes:</label>
            <textarea 
                ref={notesTextareaRef} 
                style={{ 
                    border: '1px solid #ccc', 
                    padding: '10px', 
                    borderRadius: '5px',
                    fontSize: '16px', 
                    width: '100%',   
                    height: '100px'  
                 }}
                value={inputText}
                onChange={onInputChange}
                placeholder=""
            />
        </div>
    );
};




const AdminAddTemplate = ({ templateData, onClose, setShowAddTemplatePopup}) => {
    
    const [fieldName, setFieldName] = useState('');
    const [, guard] = useSubmitGuard();
    const [showPopup, setShowPopup] = useState(false);
    const [popupFields, setPopupFields] = useState([]);
    const [selectedOption, setSelectedOption] = useState('');
    const [fieldType, setFieldType] = useState('');
    const [fieldUser, setFieldUser] = useState('');
    const [fieldQuestion, setFieldQuestion] = useState('');
    const [options, setOptions] = useState([]);
    const [nameOptions, setNameOptions] = useState([]);
    const [questionOptions, setQuestionOptions] = useState([]);
    const [selectedFieldName, setSelectedFieldName] = useState('');
    const [selectedFieldType, setSelectedFieldType] = useState('');
    const [inputValues, setInputValues] = useState({});
    const [inputText, setInputText] = useState('');
    const [showSuccessPopup, setShowSuccessPopup] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [showSnackbar, setShowSnackbar] = useState(false);
    const notesTextareaRef = useRef(null);
    const [isEditable, setIsEditable] = useState(true);
    const [eyeIconSelected, setEyeIconSelected] = useState(false);
    const navigate = useNavigate();
    

    // Inside useEffect for fetching data
    useEffect(() => {
        const config = {
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Access-Control-Allow-Methods': '*',
                'Content-Type': 'application/json'
            }
        };
    
        if (templateData) {
            setIsEditable(false);
            setFieldName(templateData.diag_id);
            setFieldType(templateData.type);
            setInputText(templateData.note_template);
        
            const mappedPopupFields = templateData.tagList.map(tag => {
                const objectInput = {}; 
                const mappingsArray = tag.mappings.split(';');//edit here
        
                mappingsArray.forEach(mapping => {
                    const parts = mapping.split(':');
                    if (parts.length === 2) {
                        objectInput[parseInt(parts[0])] = parts[1]; 
                    }
                });
        
                return {
                    name: tag.tableName,
                    qId: tag.qId.toString(),
                    blockName: tag.fieldName,
                    question: tag.question,
                    arrayInput: objectInput, 
                };
            });
        
            setPopupFields(mappedPopupFields);
        }
        
        
        //const diagnosesUrl = API_DETAILS.baseUrl + API_DETAILS.PORT + API_DETAILS.baseExtension + `/getAllDiagnoses`;
        const diagnosesUrl = API_DETAILS.baseUrl + API_DETAILS.PORT + API_DETAILS.baseExtension + `/getAllQuestionnaireFormsForNoteTemplate`;
        axios.get(diagnosesUrl, config)
            .then(response => {
                setNameOptions(response.data);
            })
            .catch(error => {
            });
    
        if (selectedOption === 'user') {
            const usersUrl = API_DETAILS.baseUrl + API_DETAILS.PORT + API_DETAILS.baseExtension + `/getUsersColumnNames`;
            axios.get(usersUrl, config)
                .then(response => {
                    setOptions(response.data);
                })
                .catch(error => {});
        } else if (selectedOption === 'question') {
            if (fieldName) {
               // const questionsUrl = API_DETAILS.baseUrl + API_DETAILS.PORT + API_DETAILS.baseExtension + `/getQuestionsBydiagId/${fieldName}`;
               const questionsUrl = API_DETAILS.baseUrl + API_DETAILS.PORT + API_DETAILS.baseExtension + `/getQuestionsBydiagId/${fieldName}`;
                axios.get(questionsUrl, config)
                    .then(response => {
                        setQuestionOptions(response.data);
                    })
                    .catch(error => {});
            }
        }
    }, [selectedOption, fieldName, templateData]);

    const handleInsertFieldName = (fieldName) => {
        const textarea = notesTextareaRef.current;
        const startPos = textarea.selectionStart;
        const endPos = textarea.selectionEnd;
        const text = textarea.value;
        const newText = text.substring(0, startPos) +'['+ fieldName+']' + text.substring(endPos, text.length);
        setInputText(newText); // Update inputText state with inserted field.blockName
        textarea.focus(); // Keep focus on the textarea
        // Set the cursor position after the inserted field.blockName
        textarea.setSelectionRange(startPos + fieldName.length, startPos + fieldName.length);
    };

    const handleOptionChange = (option) => {
        setSelectedOption(option);
        setFieldUser('');
        setFieldQuestion('');
    };

    const handleAddField = () => {
        setShowPopup(true);
        setSelectedFieldName(fieldName);
        setSelectedFieldType(fieldType);
    };

    const handleClosePopup = () => {
        setShowPopup(false);
        setFieldName(selectedFieldName);
        setFieldType(selectedFieldType);
        setFieldQuestion('');
        setInputValues({});
        setFieldUser('');
        setEyeIconSelected(false);
    };

    const handleAddFieldFromPopup = () => {
        const newField = { name: selectedOption, qId: fieldQuestion, arrayInput: inputValues, blockName: fieldUser };
        setPopupFields([...popupFields, newField]);
        // Resetting fieldName and fieldType to the previously selected values
        setFieldName(selectedFieldName);
        setFieldType(selectedFieldType);
        setFieldQuestion('');
        setInputValues({});
        setFieldUser('');
        setShowPopup(false);
    };

    const handleInputChange = (key, value) => {
        setInputValues(prevValues => ({
            ...prevValues,
            [key]: value
        }));
    };
    

    const handleInputTextChange = (event) => {
        setInputText(event.target.value);
    };

    const handleCloseSnackbar = () => {
        setShowSnackbar(false);
        setErrorMessage('');
    };
    
    const handleAddTemplate = () => {
        handleSubmitTemplate();
    }

    const handleSubmitTemplate = guard( () => {
        const config = {
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Access-Control-Allow-Methods': '*',
                'Content-Type': 'application/json'
            }
        };
        if (!fieldName || !fieldType) {
            // If any of the fields is not selected, display an error message
            toast.error("Choose a name and a type for this template, then save.");
            //setErrorMessage('Please select both Name and Type');
            //setShowSnackbar(true);
            return; // Prevent form submission
        }
        const data = {
            noteTemplate: inputText,
            diagnosisName: fieldName,
            type: fieldType,
            fields: popupFields.map(field => {
                return {
                    tableName: field.name,
                    fieldName: field.blockName,
                    qid: field.qId,
                    question: field.question,
                    inputValues: field.arrayInput
                };
            })
        };
    
        if (templateData) {
            // If templateData exists, it means we're editing an existing template
            // Send an update request to the backend
            const url = API_DETAILS.baseUrl + API_DETAILS.PORT + API_DETAILS.baseExtension +`/updateNoteTemplate/${templateData.diag_id}/${templateData.type}`;
            const request = axios.put(url,data,config)
                .then(response => {
                    if (response.data.message === 'Note template updated successfully') {
                        toast.success("Note template updated.");
                    } else {
                        setErrorMessage('Template update failed');
                        setShowSnackbar(true);
                    }
                })
                .catch(error => {
                    setErrorMessage('Error updating template');
                    setShowSnackbar(true);
                });
                setShowAddTemplatePopup(false);
                return request;
        } else {
            // If templateData does not exist, it means we're adding a new template
            // Send a create request to the backend
            const url = API_DETAILS.baseUrl + API_DETAILS.PORT + API_DETAILS.baseExtension +`/addNoteTemplate`;
            const request = axios.post(url, data, config)
                .then(response => {
                    if (response.data.message === 'Added Successfully') {
                        toast.success("Note template added. Providers can now use it.");
                       // onClose();
                        //setShowSuccessPopup(true);
                    } else {
                        setErrorMessage('Template creation failed');
                        setShowSnackbar(true);
                    }
                })
                .catch(error => {
                    setErrorMessage('Error creating template');
                    setShowSnackbar(true);
                });
                setShowAddTemplatePopup(false);
                return request;
        }
    });

    const handleCloseSuccessPopup = () => {
        setShowSuccessPopup(false);
        onClose();
        
    };
    const handlePopupFieldClose = (indexToRemove) => {
        setPopupFields(prevPopupFields => prevPopupFields.filter((_, index) => index !== indexToRemove));
    };
    const openPopup = (field) => {
        
        setSelectedOption(field.name);
        setFieldUser(field.blockName);
        setFieldQuestion(field.qId);
       // console.log("field q : ",fieldQuestion);
        setInputValues(field.arrayInput);
        setEyeIconSelected(true); // Set eyeIconSelected to true when the eye icon is clicked
        setShowPopup(true);
    };

    return (
        <div>
            <div className='hm'>
                <div className="admin-ui-table">
                    <div className="template-container" style={{ padding: '10px', borderRadius: '5px', marginLeft: '15px' }}>
                        <div style={{  backgroundColor: '#9CB189', padding: '0 10px', borderRadius: '5px', width: '150px', height: '50px', display: 'flex', alignItems: 'center', textAlign: 'center' }}>
                            <div className="add-template-button" onClick={() => handleAddField()} style={{ cursor: 'pointer', color: 'white' }}>
                                + Add Fields
                            </div>
                        </div>
                    </div>

                    <div className="block-container" style={{ marginTop: '20px', display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginLeft: '35px' }}>
                        <div className="input-block" style={{ width: '20%',minWidth: '20%', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center'}}>
                            <div style={{ width: '100%', marginBottom: '10px', marginTop: '50px', marginRight: '60px', marginLeft: '55px' }}>
                                <label htmlFor="fieldName " style={{ textAlign: 'left', display: 'block' }}>Name:<span style={{ color: 'red' }}>*</span></label>
                                <FormControl variant="outlined" style={{ width: '100%' }}>
                                    <Select style={{ background: '#FFFFFF', maxHeight: '30px' }}
                                        labelId="fieldName-label"
                                        id="fieldName"
                                        value={fieldName}
                                        onChange={(e) => setFieldName(e.target.value)}
                                        label="Name"
                                        disabled={!isEditable}
                                        
                                    >   
                                        {nameOptions.map((option, index) => (
                                            //<MenuItem key={index} value={option.diagId}>{option.name}</MenuItem>
                                            <MenuItem key={index} value={option.id}>{option.questionnaire_type}</MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                                {/* Display error message if field is required */}
                            </div>
                            <div style={{ width: '100%', marginBottom: '10px', marginTop: '50px', marginRight: '60px', marginLeft: '55px' }}>
                                <label htmlFor="fieldType" style={{ textAlign: 'left', display: 'block' }}>Type:<span style={{ color: 'red' }}>*</span></label>
                                <FormControl variant="outlined" style={{ width: '100%' }}>
                                    <InputLabel id="fieldType-label"></InputLabel>
                                    <Select style={{ background: '#FFFFFF', maxHeight: '30px' }}
                                        labelId="fieldType-label"
                                        id="fieldType"
                                        value={fieldType}
                                        onChange={(e) => setFieldType(e.target.value)}
                                        label="Type"
                                        disabled={!isEditable}
                                       // {...register("fieldType", { required: true })}
                                    >
                                        <MenuItem value=""><em>None</em></MenuItem>
                                        <MenuItem value="Initial">Initial</MenuItem>
                                        <MenuItem value="Follow-up">Follow-up</MenuItem>
                                    </Select>
            
                                </FormControl>
                  
                           
                            </div>
                        </div>
                        <div className="scrollable-block" style={{ width: '80%', maxHeight: '220px', overflowY: 'auto', padding: '10px', marginRight: '180px', display: 'flex', flexWrap: 'wrap' }}>
                            {popupFields.map((field, index) => (
                                <div key={index} style={{ position:'relative',backgroundColor: '#9CB189', padding: '5px', display: 'flex', alignItems: 'center', justifyContent: 'center', width: '150px', height: '50px', borderRadius: '5px', marginRight: '10px', marginBottom: '10px' }}>
                                    <button
                                        style={{ backgroundColor: '#9CB189', border: 'none', cursor: 'pointer' }}
                                        onClick={() => handleInsertFieldName(field.blockName)}
                                    >
                                        {field.blockName}
                                    </button>
                                    {/* Close button */}
                                    <button
                                        
                                        style={{ position: 'absolute', top: 0, right: 0, padding: '5px',backgroundColor: '#9CB189', color: 'black', border: 'none', cursor: 'pointer', borderRadius: '50%',marginRight:'4px' }}
                                        onClick={() => handlePopupFieldClose(index)}
                                    >
                                        X
                                    </button>
                                    <button
                                        style={{ position: 'absolute', top: 0, left: 0, padding: '5px', backgroundColor: '#9CB189', color: 'black', border: 'none', cursor: 'pointer', borderRadius: '50%', marginRight: '4px' }}
                                        onClick={() => openPopup(field)}
                                    >
                                        <AiOutlineEye />
                                    </button>
                                </div>
                            ))}
                        </div>
                    </div>

                    {/* Add DynamicInputBox component here */}
                    <DynamicInputBox 
                        inputText={inputText} 
                        onInputChange={handleInputTextChange} 
                        notesTextareaRef={notesTextareaRef} // Pass notesTextareaRef
                        setInputText={setInputText} // Pass setInputText
                    />

                    <div className="submit-button-container" style={{ textAlign: 'center',marginTop: 70}}>
                        <button onClick={handleAddTemplate} style={{ backgroundColor: '#9CB189', color: 'white', marginTop: '20px', padding: '10px 20px', borderRadius: '5px', border: 'none', cursor: 'pointer' }}>Submit</button>
                    </div>
                    
                    {/* Popup */}
                    <Dialog open={showPopup} onClose={handleClosePopup} fullWidth maxWidth="md">
                         <DialogTitle style={{ backgroundColor: "#eceff1" }}>Add Field</DialogTitle>
                         <DialogContent style={{ backgroundColor: "#ffffff", padding: '20px' }}>
                             <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                                 <div style={{ display: 'flex', alignItems: 'center' }}>
                                     <input
                                         type="radio"
                                         id="userRadio"
                                         name="option"
                                         value="user"
                                         checked={selectedOption === 'user'}
                                         onChange={() => handleOptionChange('user')}
                                         style={{ marginRight: '10px' }}
                                     />
                                     <label htmlFor="userRadio" style={{ marginRight: '10px', minWidth: '80px' }}>User</label>
                                     <select
                                         value={fieldUser}
                                         onChange={(e) => setFieldUser(e.target.value)}
                                         disabled={eyeIconSelected}
                                         style={{ padding: '8px', width: 'calc(80% - 100px)',fontSize: '16px' }}  // Reduce padding and width
                                     >   
                                         <option value=""><em>Select</em></option>
                                         {options.map((option, index) => (
                                             <option key={index} value={option}>{option}</option>
                                         ))}
                                     </select>
                                 </div>
                                 <div style={{ display: 'flex', alignItems: 'center' }}>
                                     <input
                                         type="radio"
                                         id="questionRadio"
                                         name="option"
                                         value="question"
                                         checked={selectedOption === 'question'}
                                         onChange={() => handleOptionChange('question')}
                                         style={{ marginRight: '10px' }}
                                     />
                                     <label htmlFor="questionRadio" style={{ marginRight: '10px', minWidth: '80px' }}>Question</label>
                                     <select
                                         value={fieldQuestion}
                                         onChange={(e) => setFieldQuestion(e.target.value)}
                                         style={{ padding: '8px', width: 'calc(80% - 100px)',fontSize: '16px' }}  // Consistent width adjustment
                                     >   
                                        <option value=""><em>Select</em></option>
                                         {questionOptions.map((option, index) => (
                                             <option key={index} value={option.questionId}>{option.question}</option>
                                         ))}
                                     </select>
                                 </div>
                                 {selectedOption === 'question' && fieldQuestion && (
                                     <div className="question-options" style={{ marginTop: '10px', padding: '10px', backgroundColor: '#f7f7f7', borderRadius: '5px' }}>
                                         <div style={{ marginBottom: '10px', display: 'flex', alignItems: 'center' }}>
                                             <label style={{ marginRight: '10px', minWidth: '80px' }}>FieldName:<span style={{ color: 'red' }}>*</span></label>
                                             <input
                                                 type="text"
                                                 value={fieldUser}
                                                 onChange={(e) => setFieldUser(e.target.value)}
                                                 style={{ padding: '8px', width: 'calc(40% - 100px)' }}  // Reduced width
                                                 required
                                             />
                                         </div>
                                         {questionOptions.find(q => q.questionId.toString() === fieldQuestion)?.options?.length > 0 ? (
                                             questionOptions.find(q => q.questionId.toString() === fieldQuestion)?.options.map((option) => (
                                                 <div key={option.oId} style={{ marginBottom: '10px', display: 'flex', alignItems: 'center' }}>
                                                     <label style={{ marginRight: '10px', minWidth: '80px' }}>{option.oName}:</label>
                                                     <input
                                                         type="text"
                                                         value={inputValues[option.oId] || ''}
                                                         onChange={(e) => handleInputChange(option.oId, e.target.value)}
                                                         onBlur={() => { if (!fieldUser) alert('Field is required!') }}
                                                         style={{ padding: '8px', width: 'calc(40% - 100px)' }}  // Maintaining size consistency
                                                         required
                                                     />
                                                 </div>
                                             ))
                                         ) : (
                                             <p style={{ marginLeft: '90px' }}>No options available.</p>
                                         )}
                                     </div>
                                 )}
                             </div>
                         </DialogContent>
                         <DialogActions style={{ backgroundColor: "#eceff1" }}>
                             <Button onClick={handleClosePopup}>Cancel</Button>
                             <Button onClick={handleAddFieldFromPopup} disabled={eyeIconSelected} color="primary">Add</Button>
                         </DialogActions>
                     </Dialog>

                    <Dialog open={showSuccessPopup} onClose={handleCloseSuccessPopup}>
                        <DialogTitle>Success</DialogTitle>
                        <DialogContent>
                            <div>Template Added Successfully!</div>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={handleCloseSuccessPopup} color="primary">
                                OK
                            </Button>
                        </DialogActions>
                    </Dialog>
                    <Snackbar
                        open={showSnackbar}
                        autoHideDuration={6000}
                        onClose={handleCloseSnackbar}
                        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                        style={{ top: 'calc(80px' }} // Snackbar position
                    >
                        <Alert
                            onClose={handleCloseSnackbar}
                            severity="error"
                            sx={{
                                backgroundColor: '#8B0000', // Adjust color intensity
                                color: 'white', // Text color
                                fontSize: '1.2rem', // Adjust font size
                            }}>
                            {errorMessage}
                        </Alert>
                    </Snackbar>
                </div>
            </div>
        </div>
    );
};

export default AdminAddTemplate;



